module.exports = __webpack_public_path__ + "img/draw.92384fc3.svg";